"use strict"; // Sh**t! I Smoke
// Copyright (C) 2018-2020  Marcelo S. Coelho, Amaury Martiny

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;
exports.BoxButton = void 0; // Sh**t! I Smoke is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
// Sh**t! I Smoke is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
// You should have received a copy of the GNU General Public License
// along with Sh**t! I Smoke.  If not, see <http://www.gnu.org/licenses/>.

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var theme = __importStar(require("../util/theme"));

var styles = react_native_1.StyleSheet.create({
  activeText: {
    opacity: 1
  },
  boxButton: __assign(__assign({}, theme.elevationShadowStyle(3)), {
    backgroundColor: 'white',
    borderColor: 'rgba(0, 0, 0, 0.1)',
    borderRadius: 12,
    borderWidth: 1,
    marginBottom: theme.spacing.mini,
    paddingHorizontal: theme.spacing.small,
    paddingVertical: 6,
    shadowOpacity: 0.1
  }),
  boxButtonText: __assign(__assign({}, theme.shitText), {
    opacity: theme.disabledOpacity,
    textAlign: 'center'
  })
});

function BoxButton(props) {
  var active = props.active,
      children = props.children,
      onPress = props.onPress,
      style = props.style,
      rest = __rest(props, ["active", "children", "onPress", "style"]);

  return react_1["default"].createElement(react_native_1.TouchableWithoutFeedback, __assign({
    onPress: onPress
  }, rest), react_1["default"].createElement(react_native_1.View, {
    style: [styles.boxButton, style]
  }, typeof children === 'string' ? react_1["default"].createElement(react_native_1.Text, {
    style: [styles.boxButtonText, active ? styles.activeText : undefined]
  }, children) : children));
}

exports.BoxButton = BoxButton;